//system
import { Injectable } from '@angular/core';
import { HttpService, HttpServiceConfig } from './common/http.service';
import { Observable } from 'rxjs';

//environment
import { environment } from 'src/environments/environment';

//models
import { OpenGraphMetadata } from 'src/app/models/invite-code';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class InviteCodeService {

  constructor(private httpService: HttpService, private environmentService: EnvironmentService) { 
    const config: HttpServiceConfig = {
      baseUrl: `${this.environmentService.getFacilityConfig().facilityUrl}api/v${this.environmentService.getFacilityConfig().facilityApiVersion}`
    };
    this.httpService.configure(config);
  }

  getOpenGraphMetadata(inviteCode: string): Observable<OpenGraphMetadata> {
    return this.httpService.get<OpenGraphMetadata>(`InviteCode/OpenGraphMetadata/${inviteCode}`);
  }
}
